<template>
	<v-list-group
		:value="value"
		:prepend-icon="icon"
	>
		<template v-slot:activator>
			<v-list-item-title>{{ title }}</v-list-item-title>
		</template>

		<div>
			<slot></slot>
		</div>
	</v-list-group>
</template>

<script>
export default {
	props: {
		icon: String,
		title: String,
		value: {
			type: Boolean,
			default: false,
		},
	},
}
</script>
